import React from 'react'
import createFormActions from "./create-form-actions"
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import FormInputContainer from "../../../components/_common/FormInputContainer"

export default function createConnectedInput(formName) {
    return (inputName, WrappedComponent) => {

        const actions = createFormActions(formName)

        const mapStateToProps = (state) => {
            const formState = state[formName]

            return {
                value: formState.values[inputName],
                errorMessages: formState.errorMessages[inputName],
                dirty: formState.dirtyFields[inputName],
                showValidationErrors: formState.showValidationErrors,
            }
        }

        const mapDispatchToProps = (dispatch) => bindActionCreators({
            changeValue: (value) => actions.changeValue(inputName, value),
        }, dispatch)


        return connect(mapStateToProps, mapDispatchToProps)(
            class HOC extends React.Component {

                render() {
                    return (
                        <FormInputContainer label={this.props.label}
                                            errorMessages={this.props.errorMessages}
                                            showError={this.props.dirty || this.props.showValidationErrors}>

                            <WrappedComponent
                                {...this.props}
                                changeValueAction={this.props.changeValue}
                            />
                        </FormInputContainer>
                    )
                }
            }
        )


    }
}



// WEBPACK FOOTER //
// ./src/redux/actions-reducers/form/create-connected-input.js